import axios from 'axios';

export const setNewUser = async ({
  firstName,
  lastName,
  userType,
  emailID,
  reportsTo,
  location,
  designation,
}) => {
  const path = `/api/admin/v1/user/createNewUser`;
  const userDetails = {
    firstName,
    lastName,
    userType,
    emailID,
    reportsTo,
    location,
    designation,
  };
  const headers = {
    'Content-Type': 'application/json',
  };
  const { status, data } = await axios.post(path, userDetails, { headers });
  return { status, data };
};
